import _ from "lodash";
// Use this file to add any utility functions that are used to match routes

export const isPublicPlatformRoute = () => {
  return (
    _.includes(window.location.href, "platform/public") &&
    !_.includes(window.location.href, "platform/public/post")
  );
};

export const isLibraryResourceRoute = () => {
  const url = window.location.href;

  // Check if the URL contains "toddle-library"
  if (!url.includes("toddle-library")) {
    return false;
  }

  // Define the patterns to match
  const patterns = ["/assessment/", "/units/", "/worksheet/", "/question/"];

  // Check if any of the patterns match
  for (const pattern of patterns) {
    const regex = new RegExp(pattern + "[\\w]+");
    if (regex.test(url)) {
      return true;
    }
  }

  return false;
};

export const isToddleLibraryRoute = () => {
  return _.includes(window.location.href, "/toddle-library");
};

export const isToddleLibraryRouteBySegment = () => {
  const url = window.location.href;
  const urlSegments = url.split("/");
  const hasToddleLibrary = _.includes(urlSegments, "toddle-library");
  return hasToddleLibrary;
};
